import Vue from 'vue';
import VueRouter from 'vue-router';
const index = '/queryCenter/index';
Vue.use(VueRouter);
const routes = [{
  path: '/',
  redirect: '/home'
}, {
  path: '/home',
  component: () => import('../views/IFindHome.vue')
}];
const router = new VueRouter({
  routes
});
export default router;